var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._g(_vm._b({staticClass:"zoox-component zoox-card",class:{shadow: _vm.shadow || _vm.$zoox.cardShadow},attrs:{"width":_vm.width}},'v-card',_vm.$attrs,false),_vm.$listeners),[(_vm.title || _vm.$scopedSlots['actions'] || _vm.$scopedSlots['title'])?_c('div',{staticClass:"card-title-container",style:({
      'grid-template-columns': _vm.$scopedSlots['actions'] ? '1fr auto' : '1fr',
    })},[_vm._t("title",function(){return [_c('span',{staticClass:"card-title",class:{
          start: _vm.justifyTitle === 'start',
          center: _vm.justifyTitle === 'center',
          end: _vm.justifyTitle === 'end',
        }},[_vm._v(" "+_vm._s(_vm.title)+" ")])]}),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)],2):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }